import React from 'react';
import MainLayout from '../Layout/MainLayout';
import SitesTab from './tabs/SitesTab';
import SweepsTab from './tabs/SweepsTab';
import { useAuth } from '../../contexts/AuthContext';
import { isLawEnforcementPlan } from '../../utils/subscriptionCategory';

/**
 * Law-enforcement tenants see "Sweeps" (field operations); corporate tenants see site inventory.
 */
const SitesPage: React.FC = () => {
  const { userProfile } = useAuth();
  const le = isLawEnforcementPlan(userProfile?.subscriptionPlan);

  return (
    <MainLayout title={le ? 'Sweeps' : 'Sites & Locations'}>
      {le ? <SweepsTab /> : <SitesTab />}
    </MainLayout>
  );
};

export default SitesPage;
